<template>
  <div>
    <v-container>
      <h1 class="text-h3 font-weight-light light--text text-center pt-6 pb-6">
        Ubiquity Internet Sign Up
      </h1>
      <v-card dark class="pt-4 px-8 pb-4">
        <v-form v-model="valid">
          <v-card-title class="lightGreen--text pb-6"
            >* Indicates required</v-card-title
          >
          <v-row justify-sm="center">
            <v-col sm="11">
              <v-text-field
                v-model="customer.firstName"
                label="*First Name"
                placeholder="*Last Name"
                :disabled="isLoading"
                :rules="[rules.required]"
                dense
                outlined
                rounded
                required
                dark
              ></v-text-field>

              <v-text-field
                v-model="customer.lastName"
                label="*Last Name"
                placeholder="*Last Name"
                :disabled="isLoading"
                :rules="[rules.required]"
                dense
                outlined
                rounded
                required
                dark
              ></v-text-field>

              <v-text-field
                v-model="customer.company"
                label="Business Name (if applicable)"
                placeholder="Business Name (if applicable)"
                :disabled="isLoading"
                dense
                outlined
                rounded
                dark
              ></v-text-field>

              <v-select
                :items="dataplans"
                label="*Dataplan / Package"
                item-text="displayName"
                v-model="selectedDataplan"
                outlined
                rounded
                dense
                dark
                :rules="[rules.required]"
              ></v-select>

              <v-text-field
                v-model="customer.email"
                label="*Email"
                placeholder="*Email"
                :disabled="isLoading"
                dense
                outlined
                rounded
                dark
                :rules="[rules.required]"
              ></v-text-field>

              <v-text-field
                v-model="customer.phone"
                label="*Phone"
                placeholder="*Phone"
                :disabled="isLoading"
                dense
                outlined
                rounded
                dark
                :rules="[rules.required]"
              ></v-text-field>

              <v-text-field
                v-model="customer.address1"
                label="*Address 1"
                placeholder="*Address 1"
                :disabled="isLoading"
                dense
                outlined
                rounded
                dark
                :rules="[rules.required]"
              ></v-text-field>

              <v-text-field
                v-model="customer.address2"
                label="Address 2"
                placeholder="Address 2"
                :disabled="isLoading"
                dense
                outlined
                rounded
                dark
              ></v-text-field>

              <v-text-field
                v-model="customer.city"
                label="*City"
                placeholder="*City"
                :disabled="isLoading"
                dense
                outlined
                rounded
                dark
                :rules="[rules.required]"
              ></v-text-field>

              <v-select
                v-model="customer.state"
                :items="states"
                color="dark"
                label="*State"
                outlined
                rounded
                dense
                dark
                :rules="[rules.required]"
              ></v-select>

              <v-text-field
                v-model="customer.zip"
                label="*Zip Code"
                placeholder="*Zip Code"
                :disabled="isLoading"
                dense
                outlined
                rounded
                dark
                :rules="[rules.required]"
              ></v-text-field>

              <p class="light--text pl-5">*Date of Birth:</p>
              <v-date-picker
                v-model="dateOfBirth"
                color="darkRed"
                class="pb-8 pl-5"
                :rules="[rules.required]"
              ></v-date-picker>

              <v-textarea
                v-model="customer.notes"
                label="Notes (Optional)"
                placeholder="Notes (Optional)"
                :disabled="isLoading"
                outlined
                rounded
                auto-grow
                clearable
                dark
              ></v-textarea>

              <signature-component
                v-if="!isLoading"
                class="pb-5"
                @updateSignature="updateSignatureMethod"
              ></signature-component>

              <v-divider class="pb-5"></v-divider>

              <p class="light--text">Payment Information:</p>

              <v-text-field
                v-model="creditInfo.nameOnTheCard"
                label="*Name on Card"
                placeholder="*Name on Card"
                :disabled="isLoading"
                dense
                outlined
                rounded
                dark
                :rules="[rules.required]"
              ></v-text-field>

              <v-text-field
                v-model="creditInfo.cardNumber"
                label="*Card Number"
                placeholder="*Card Number"
                :disabled="isLoading"
                dense
                outlined
                rounded
                dark
                :rules="[rules.required]"
              ></v-text-field>

              <v-row class="pa-3">
                <v-select
                  v-model="creditInfo.expiryMonth"
                  :items="months"
                  color="dark"
                  class="mr-3"
                  label="*Expiration Month"
                  outlined
                  rounded
                  dense
                  dark
                  :rules="[rules.required]"
                ></v-select>

                <v-text-field
                  v-model="creditInfo.expiryYear"
                  label="*Expiration Year"
                  placeholder="*Expiration Year"
                  :disabled="isLoading"
                  dense
                  outlined
                  rounded
                  dark
                  :rules="[rules.required]"
                ></v-text-field>
              </v-row>

              <p v-if="showError" class="light--text mb-16">{{ errorText }}</p>

              <v-divider dark class="pt-6"></v-divider>

              <v-btn
                rounded
                x-large
                class="ml-4"
                color="lightBlue lighter--text"
                v-if="!isLoading"
                :disabled="isLoading"
                @click="saveCustomer()"
                >SUBMIT
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import axios from "../axios/axios";
import router from "../router/index";
import signatureComponent from "../components/Customer/SignatureComponent.vue";

export default {
  mounted() {
    this.onShow();
  },
  components: {
    signatureComponent,
  },
  computed: {
    keyCode() {
      return this.$route.params.keyCode;
    },
  },
  methods: {
    onShow() {
      window.scrollTo(0, 0);

      this.getTowerData();
    },
    async saveCustomer() {
      if (!this.valid) {
        this.errorText = "Missing required * values.";
        this.showError = true;
        return;
      }
      this.isLoading = true;

      if (this.dateOfBirth) {
        this.customer.birthday = this.dateOfBirth;
      }

      for (const dataplan of this.dataplans) {
        if (dataplan.displayName === this.selectedDataplan) {
          this.customer.dataPlan = dataplan.chrgOvrId.toString();
          break;
        }
      }

      try {
        await axios.post(
          "/self-sign-up-links/customer-self-sign-up/" + this.keyCode,
          {
            customer: this.customer,
            creditInfo: this.creditInfo,
          }
        );

        router.push({ path: "/success" });
      } catch (error) {
        alert(error.response.data.message);
      }

      this.isLoading = false;
    },
    async getTowerData() {
      try {
        const res = await axios.get(
          "/self-sign-up-links/tower-data/" + this.keyCode
        );
        this.link = res.data.link;

        this.customer.tower = this.link.towerName;
        this.customer.salesName = 'SELF SIGN-UP'
        this.dataplans = res.data.dataplans;
      } catch (error) {
        router.push({ path: "/expired" });
      }
    },
    updateSignatureMethod(value) {
      this.customer.signature = value;
    },
  },
  data: () => ({
    isLoading: false,
    customer: {},
    creditInfo: {},
    link: {},
    dataplans: [],
    selectedDataplan: "",
    dateOfBirth: "",
    errorText: "",
    showError: false,
    valid: false,
    rules: {
      required: (value) => !!value || "Required.",
    },
    months: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    states: [
      "UT",
      "PA",
      "AK",
      "AL",
      "AR",
      "AZ",
      "CA",
      "CO",
      "CT",
      "DE",
      "FL",
      "GA",
      "HI",
      "IA",
      "ID",
      "IL",
      "IN",
      "KS",
      "KY",
      "LA",
      "MA",
      "MD",
      "ME",
      "MI",
      "MN",
      "MO",
      "MS",
      "MT",
      "NC",
      "ND",
      "NE",
      "NH",
      "NJ",
      "NM",
      "NV",
      "NY",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VA",
      "VT",
      "WA",
      "WI",
      "WV",
      "WY",
    ],
  }),
};
</script>

<style>
</style>